<template>
    <b-card
        header-bg-variant="secondary"
        header-text-variant="white"
        header="Alertas recentes (última semana)"
        class="shadow-sm"
    >
        <div class="mb-3">
            <b-form-radio-group
                id="alert_category_id"
                v-model="alertCategorySelected"
                :options="categoryOptions"
                name="radio-options"
                button-variant="outline-secondary"
                buttons
            />
        </div>
        <b-row>
            <b-col xl="4" class="mb-2 mb-xl-0">
                <alert-card
                    title="críticos"
                    icon="fa-times-circle"
                    variant="danger"
                    :total="totalCritical"
                    :selected="alertLevelSelected === AlertLevels.CRITICAL"
                    @select="onSelect(AlertLevels.CRITICAL)"
                />
            </b-col>
            <b-col xl="4" class="mb-2 mb-xl-0">
                <alert-card
                    title="avisos"
                    icon="fa-exclamation-circle"
                    variant="warning"
                    :total="totalWarning"
                    :selected="alertLevelSelected === AlertLevels.WARNING"
                    @select="onSelect(AlertLevels.WARNING)"
                />
            </b-col>
            <b-col xl="4">
                <alert-card
                    title="informações"
                    icon="fa-info-circle"
                    variant="info"
                    :total="totalInfo"
                    :selected="alertLevelSelected === AlertLevels.INFO"
                    @select="onSelect(AlertLevels.INFO)"
                />
            </b-col>
        </b-row>
        <alert-table
            :items="alerts"
            class="mt-3"
            :per-page="perPage"
            :current-page="currentPage"
            sortable
        />
        <b-pagination
            v-model="currentPage"
            :total-rows="alerts.length"
            :per-page="perPage"
            first-text="Primeira página"
            last-text="Última página"
            align="center"
        />
    </b-card>
</template>

<script>
import { mapState } from "vuex";
import { AlertLevels, AlertCategories } from "@/modules/common/settings";
import AlertCard from "./AlertCard";
import AlertTable from "./AlertTable";

export default {
    name: "AlertRecent",
    components: {
        AlertCard,
        AlertTable
    },
    data() {
        return {
            currentPage: 1,
            alertLevelSelected: AlertLevels.CRITICAL,
            alertCategorySelected: AlertCategories.STRUCTURE
        };
    },
    computed: {
        ...mapState("common/alerts", ["recents"]),
        totalCritical() {
            return this.allAlerts.reduce(
                (total, item) =>
                    item.alert_level === AlertLevels.CRITICAL
                        ? total + 1
                        : total,
                0
            );
        },
        totalWarning() {
            return this.allAlerts.reduce(
                (total, item) =>
                    item.alert_level === AlertLevels.WARNING
                        ? total + 1
                        : total,
                0
            );
        },
        totalInfo() {
            return this.allAlerts.reduce(
                (total, item) =>
                    item.alert_level === AlertLevels.INFO ? total + 1 : total,
                0
            );
        },
        allAlerts() {
            return this.recents.filter(
                item => item.alert_category === this.alertCategorySelected
            );
        },
        alerts() {
            return this.allAlerts.filter(
                item => item.alert_level === this.alertLevelSelected
            );
        },
        categoryOptions() {
            return [
                {
                    html: `<i class="fas fa-wrench fa-fw mr-2"></i>${
                        AlertCategories[AlertCategories.STRUCTURE]
                    }`,
                    value: AlertCategories.STRUCTURE
                },
                {
                    html: `<i class="fas fa-desktop fa-fw mr-2"></i>${
                        AlertCategories[AlertCategories.SYSTEM]
                    }`,
                    value: AlertCategories.SYSTEM
                }
            ];
        }
    },
    created() {
        this.perPage = 5;
        this.AlertLevels = AlertLevels;

        if (
            this.recents.find(item => item.alert_level === AlertLevels.CRITICAL)
        ) {
            this.alertLevelSelected = AlertLevels.CRITICAL;
        } else if (
            this.recents.find(item => item.alert_level === AlertLevels.WARNING)
        ) {
            this.alertLevelSelected = AlertLevels.WARNING;
        } else if (
            this.recents.find(item => item.alert_level === AlertLevels.INFO)
        ) {
            this.alertLevelSelected = AlertLevels.INFO;
        }
    },
    methods: {
        onSelect(alertLevel) {
            this.alertLevelSelected = alertLevel;
        }
    }
};
</script>
